<div class="custom-button-container">
  <button
    [type]="type"
    [ngClass]="buttonClass"
    [ngStyle]="buttonStyle"
    [disabled]="isDisabled"
    (click)="onClick($event)"
    (keydown)="onKeydown($event)"
    tabindex="0"
    [matTooltip]="tooltip"
    [attr.aria-label]="ariaLabel"
    [matTooltipPosition]="'below'"
    [matTooltipClass]="tooltipClass"
    [title]="title"
  >
    <ng-content></ng-content>
  </button>
</div>
